import React from 'react';
import { Button, Flex, Form, Input } from 'antd';

import { useForm } from 'antd/es/form/Form';
import { usePostWhatsappGroupMutation } from 'src/redux/services/centralApi';
import DashboardTemplate from 'src/templates/DashboardTemplate';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

interface IForm {
	groupName: string;
}

export default function AddWhatsappGroupPage() {
	const [ form, ] = useForm<IForm>();
	const [ postWppGroup, postWppGroupResult, ] = usePostWhatsappGroupMutation();
	const navigate = useNavigate();

	const onFinishForm = (values: IForm) => {
		postWppGroup({
			name: values.groupName,
		})
			.unwrap()
			.then(async (response) => {
				const invitationLink = response?.payload?.invitationLink;

				if (invitationLink) {
					try {
						await navigator.clipboard.writeText(invitationLink);
						toast.success(
							'Grupo criado! Link de convite copiado para a área de transferência.',
							{ autoClose: 3000, }
						);
					} catch {
						toast.success(
							`Grupo criado! Link de convite: ${invitationLink}`,
							{ autoClose: 5000, }
						);
					}
				} else {
					toast.success('Grupo do Whatsapp criado com sucesso!', {
						autoClose: 1000,
					});
				}

				form.resetFields();
				navigate('/comunicacao/whatsapp/grupos/listar');
			})
			.catch((err) => {
				if (err?.status && err?.status === 500 && err?.data?.frontend_message) {
					toast.error(err?.data?.frontend_message, { autoClose: 3000, });
				}
			});
	};

	return (
		<DashboardTemplate pageTitle="Adicionar Grupo do Whatsapp">
			<Form form={form} layout="vertical" onFinish={onFinishForm}>
				<Form.Item
					name="groupName"
					required
					hasFeedback
					rules={[
						{
							required: true,
							message:
								'Por favor, insira o nome do grupo do Whatsapp',
						},
					]}
					tooltip={'Nome do grupo do Whatsapp'}
					label={'Nome do grupo'}
				>
					<Input placeholder="Nome do grupo" />
				</Form.Item>

				<Form.Item>
					<Flex justify="flex-end">
						<Button
							onClick={() => {
								form.submit();
							}}
							disabled={!!postWppGroupResult?.isLoading}
							loading={!!postWppGroupResult?.isLoading}
							htmlType="submit"
							type="primary"
						>
							Criar grupo
						</Button>
					</Flex>
				</Form.Item>
			</Form>
		</DashboardTemplate>
	);
}
